import '../styles/FormItem.scss';

import AntdForm      from 'antd/lib/form';
import React         from 'react';
import useForm       from '@widesk-ui/hooks/useForm';
import { FormRule }  from 'antd';
import { ReactNode } from 'react';

type FormItemProps = {
	label?: string;
	name: string | string[];
	initialValue?: unknown;
	children: React.ReactElement<FieldProps>;
	required?: boolean;
	rules?: FormRule[];
	extra?: ReactNode;
	style?: React.CSSProperties;
}

export function FormItem(props: FormItemProps) {
	const { children, extra, name, label, initialValue, required } = props;

	const { fields } = useForm();
	const field = (fields || {})[Array.isArray(name) ? '' : name];

	const updatedChildren = React.Children.map(children, child => {
		if (React.isValidElement(child)) {
			return React.cloneElement(child, {
				...(() => {
					const disabled = child.props.disabled || field?.disabled;
					if (disabled !== undefined) return { disabled };
					return {};
				})(),
				'aria-label': child.props['aria-label'] || label,
				placeholder: child.props.placeholder || field?.label,
				style: { width: '100%', ...child.props.style },
			});
		}
		return child;
	});

	return (
		<AntdForm.Item
			extra={extra}
			className="widesk-form-item"
			name={name}
			label={label}
			initialValue={initialValue}
			style={props.style}
			rules={[{ required, message: 'Veuillez renseigner cette information' }, ...(props.rules || [])]}
		>
			{updatedChildren}
		</AntdForm.Item>
	);
}
